module.exports = __webpack_public_path__ + "static/video_slide_1-a3623459cbbe349afe31fbb3bd5a215d.mp4";